import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
@Injectable()
export class BasePathService {
    pathRef: string;
    constructor(private router: Router) {
        let location = window.location;
        this.pathRef = location.href.replace(this.router.url, '/');

 
    }
}
